import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { doc, getDoc } from "firebase/firestore";

import { auth, db } from "../../firebase";

const ALLOWED_ROLES = new Set([
  "super_admin",
  "finance_admin",
  "support_admin",
  "moderation_admin",
  "verification_admin",
]);

function isAdminUser(userData) {
  if (!userData) return false;

  if (userData.admin === true || userData.isAdmin === true) {
    return true;
  }

  const roleRaw = userData.role;

  if (Array.isArray(roleRaw)) {
    const normalizedRoles = roleRaw
      .map((item) => String(item || "").trim().toLowerCase())
      .filter(Boolean);

    if (normalizedRoles.includes("admin")) return true;
    return normalizedRoles.some((role) => ALLOWED_ROLES.has(role));
  }

  const role = String(roleRaw || "").trim().toLowerCase();
  if (!role) return false;

  if (role.includes("admin")) return true;
  return ALLOWED_ROLES.has(role);
}

export default function RequireAdmin1({ children }) {
  const { t } = useTranslation();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let cancelled = false;

    async function checkAccess() {
      const user = auth.currentUser;
      if (!user) {
        if (!cancelled) setStatus("not_logged_in");
        return;
      }

      try {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        const userData = userSnap.exists() ? userSnap.data() : null;

        if (cancelled) return;
        setStatus(isAdminUser(userData) ? "allowed" : "denied");
      } catch (error) {
        console.error("RequireAdmin1 check failed:", error);
        if (!cancelled) setStatus("denied");
      }
    }

    checkAccess();

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "checking") {
    return <div className="admin1-state">{t("admin.checking_access", { defaultValue: "Checking admin access..." })}</div>;
  }

  if (status === "not_logged_in") {
    return <div className="admin1-state">{t("admin.login_required", { defaultValue: "Admin login required" })}</div>;
  }

  if (status === "denied") {
    return <div className="admin1-state">{t("admin.access_denied", { defaultValue: "Access denied" })}</div>;
  }

  return children;
}
